import { IonDate } from "../i-components/IonDate.tsx";

const CheckNotNull = Symbol("CheckNotNull");

class Event {
    public eventID: string = '';
    public event_categoryID: string = '';
    public event_name: string = '';
    public event_name_highlight_texts: string[] = [] as string[];
    public event_name_highlight_colors: string[] = [] as string[];
    public event_desc: string = '';
    public event_poster: string = '';
    public event_file: string = '';
    public event_venue: string = '';
    public registration_start_date: Date | null = null;
    public registration_end_date: Date | null = null;
    public early_bird_start_date: Date | null = null;
    public early_bird_end_date: Date | null = null;
    public event_start_date: Date | null = null;
    public event_end_date: Date | null = null;
    public event_schedules: any[] = []; // [[Day1_StartDateTime, Day1_EndDateTime],[Day2_StartDateTime,Day2_EndDateTime]]
    public max_pax: number = 0;
    public hostID: string = '';
    public datetime_created: Date | null = null;
    public datetime_updated: Date | null = null;

    //extras - not in db table
    public event_start_datetime: Date | null = null;
    public event_end_datetime: Date | null = null;
    public first_gallery_img: string = '';
    // public attachment_base_url: string = '';
    // public attachment_file_names: string[] = [] as string[]; --moved to eventItems

    constructor(
        eventID: string,
        event_categoryID: string,
        event_name: string,
        event_name_highlight_texts: string,
        event_name_highlight_colors: string,
        event_desc: string,
        event_poster: string,
        event_file: string,
        event_venue: string,
        registration_start_date: string,
        registration_end_date: string,
        early_bird_start_date: string,
        early_bird_end_date: string,
        event_start_date: string,
        event_end_date: string,
        event_schedules: string,
        max_pax: string,
        hostID: string,
        datetime_created: string,
        datetime_updated: string,
        first_gallery_img?: string
        // attachment_base_url: string,
        // attachment_file_names: string
    ) {
        this.eventID = this[CheckNotNull](eventID) ? eventID : '';
        this.event_categoryID = this[CheckNotNull](event_categoryID) ? event_categoryID : '';
        this.event_name = this[CheckNotNull](event_name) ? event_name : '';
        this.event_name_highlight_texts = this[CheckNotNull](event_name_highlight_texts) ? event_name_highlight_texts.split(',') : [];
        this.event_name_highlight_colors = this[CheckNotNull](event_name_highlight_colors) ? event_name_highlight_colors.split(',') : [];
        this.event_desc = this[CheckNotNull](event_desc) ? event_desc : '';
        this.event_poster = this[CheckNotNull](event_poster) ? event_poster : '';
        this.event_file = this[CheckNotNull](event_file) ? event_file : '';
        this.event_venue = this[CheckNotNull](event_venue) ? event_venue : '';
        this.registration_start_date = this[CheckNotNull](registration_start_date) ? IonDate(registration_start_date + ' 00:00:00') : null;
        this.registration_end_date = this[CheckNotNull](registration_end_date) ? IonDate(registration_end_date + ' 00:00:00') : null;
        this.early_bird_start_date = this[CheckNotNull](early_bird_start_date) ? IonDate(early_bird_start_date + ' 00:00:00') : null;
        this.early_bird_end_date = this[CheckNotNull](early_bird_end_date) ? IonDate(early_bird_end_date + ' 00:00:00') : null;
        this.event_start_date = this[CheckNotNull](event_start_date) ? IonDate(event_start_date + ' 00:00:00') : null;
        this.event_end_date = this[CheckNotNull](event_end_date) ? IonDate(event_end_date + ' 00:00:00') : null;
        this.event_schedules = this[CheckNotNull](event_schedules) ?
            event_schedules.split(',').map((dateTimeString: string) => {
                const dateTimeArr = dateTimeString.split(' ');
                const timeArr = dateTimeArr[1].split('-');

                return [
                    IonDate(dateTimeArr[0] + ' ' + timeArr[0] + ':00'),
                    IonDate(dateTimeArr[0] + ' ' + timeArr[1] + ':00')
                ];
            })
            :
            [];
        this.max_pax = this[CheckNotNull](max_pax) ? parseInt(max_pax) : 0;
        this.hostID = this[CheckNotNull](hostID) ? hostID : '';
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
        this.datetime_updated = this[CheckNotNull](datetime_updated) ? IonDate(datetime_updated) : null;

        //extras
        //get start_datetime  end_datetime
        if(this.event_schedules.length > 0) {
            //format: [[Day1_StartDateTime, Day1_EndDateTime],[Day2_StartDateTime,Day2_EndDateTime]]
            this.event_start_datetime = this.event_schedules[0][0];
            this.event_end_datetime = this.event_schedules[this.event_schedules.length - 1][1];
        } else {
            this.event_start_datetime = this.event_start_date;
            this.event_end_datetime = this.event_end_date;
        }

        if(first_gallery_img != undefined)
            this.first_gallery_img = first_gallery_img;
    }

    private [CheckNotNull] = (value: string) => {
        if (value != undefined && value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default Event;